export default __webpack_public_path__ + "assets/icons/formEdit.c4848164.svg";